import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Footer from "./Footer";
const Privacypolicy = () => {
  return (
    <>
      <div style={{ overflowX: "hidden", width: "100%" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #0e9bff, #3ac8ff)",
            padding: "13px 0",
            color: "white",
            textAlign: "center",
            fontWeight: "600",
            letterSpacing: ".5px",
          }}
        >
          <span style={{ fontSize: "1.2rem" }}>
            ⚡ Get Instant Loan Approval with us — Apply Now!
          </span>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-9">
            <div className="card-body p-4 p-md-5">
              <h1 className="mb-4 text-center fw-bold">Privacy Policy</h1>

              <p>
                Shubhpaisa Finance Private Limited and its subsidiary and/or
                affiliate companies as defined under relevant laws including
                Shubhpaisa Finance Private (hereinafter referred to as "we,"
                "our," or "us”), take the privacy of their customers, or any
                other person visiting or using any office, branch, website,
                portal, application or other platform provided by Shubhpaisa
                Finance Private Limited or communicating with us over telephone,
                WhatsApp, face-to-face or any other method or availing the
                products and services physically or vide the online application
                forms and questionnaires (hereinafter referred to as
                “User/you/your”) very seriously and are committed to protect
                your personal data. This Privacy Policy sets out the way in
                which we collect, use, disclose, transfer, and store your
                personal data. You are advised to carefully read the Privacy
                Policy before using this or any other platform, application or
                channels or communicating with us or sharing information/data.
                Shubhpaisa Finance Private Limited will not be liable /
                responsible for any breach of privacy owing to User’s
                negligence.
              </p>

              <hr />

              <h4 className="mt-4">
                What Data Do We Collect From You and What Do We Use It For?
              </h4>
              <ol className="mt-3">
                <li className="mb-3">
                  Personal data refers to any information that can be used to
                  identify or contact an individual. This includes details such
                  as your name, address, email address, PAN, username, location,
                  employment information, telephone number, age, date of birth,
                  gender, and any other KYC (Know Your Customer) data you
                  provide through our application. It also includes sensitive
                  information, such as health-related data.
                </li>

                <li className="mb-3">
                  We will not access mobile phone resources such as files,
                  media, contact lists, call logs, or telephony functions.
                  However, we may request one-time access to the camera,
                  microphone, location, or other features necessary for
                  onboarding and KYC requirements, but only with your consent or
                  as specified in this document.
                </li>

                <li className="mb-3">
                  All personal data we collect from you will be recorded,
                  utilized, and safeguarded in accordance with applicable data
                  protection legislation and this Privacy Policy. We are
                  committed to ensuring your information is protected and used
                  responsibly. Additionally, we may enhance the data you provide
                  by incorporating information obtained through our interactions
                  with you or from other organizations, such as our sponsors and
                  partners. This helps us better understand your needs and
                  deliver more tailored services. By using our services, you
                  consent to the collection and use of your information as
                  described in this policy.
                </li>
                <li className="mb-3">
                  {" "}
                  We may collect personal data through conversations with our
                  employees, representatives, or customer service agents at
                  Shubhpaisa Finance , as well as through other communication
                  methods. This includes information you submit via documents,
                  images, or in any form, whether physical or digital. You
                  acknowledge that any such communication, whether written or
                  verbal, may be recorded to comply with Shubhpaisa Finance
                  internal processes and applicable laws. Your consent to this
                  recording is implied by your engagement with our services,
                  ensuring we maintain the highest standards of service and
                  compliance.
                </li>
                <li className="mb-3">
                  To facilitate onboarding for specific services, we may require
                  access to your device's SMS features. Certain applications may
                  collect transactional SMS data, including sender names,
                  message content, and timestamps, and share this information
                  with third parties. This data is used to assess your spending
                  and financial patterns, aiding in credit evaluations, which
                  can result in faster approval processes and higher credit
                  limits. Please note that we do not access or analyze personal
                  messages. Your privacy is important to us, and we handle all
                  information in accordance with applicable data protection
                  laws.
                </li>

                <li className="mb-3">
                  {" "}
                  "By accessing our platform and providing your personal data,
                  you represent and warrant that you are at least 18 years of
                  age and have the legal capacity to enter into a binding
                  contract in accordance with applicable laws."
                </li>
              </ol>

              <hr />

              <h4 className="mt-4">Legal Basis for Processing:</h4>
              <p>
                ShubhPaisa Finance Private Limited processes your personal data
                in accordance with applicable data protection laws and
                regulations. The legal bases for processing your personal data
                include:
              </p>
              <ol className="mt-3">
                <li className="mb-3">
                  Consent: Where required, we process your data based on the
                  consent you provide at the time of registration, application,
                  or use of our services. You have the right to withdraw this
                  consent at any time, subject to legal or contractual
                  obligations.
                </li>

                <li className="mb-3">
                  Contractual Necessity: We process your information to fulfill
                  the contractual obligations arising from any agreement you
                  enter into with us, such as processing loan applications,
                  disbursing funds, and managing your account.
                </li>

                <li className="mb-3">
                  Legal and Regulatory Obligations: We are required by various
                  laws, including the Reserve Bank of India (RBI) guidelines,
                  KYC/AML regulations, and applicable tax laws, to collect and
                  retain certain personal information.
                </li>
                <li className="mb-3">
                  Legitimate Interests: We may process your data for our
                  legitimate business interests, such as fraud prevention,
                  internal record keeping, service improvement, analytics, and
                  ensuring platform security, provided that such interests do
                  not override your fundamental rights and freedoms.
                </li>
              </ol>
              <p>
                Each processing activity is carried out with due regard to your
                rights, and only to the extent necessary for the purpose it
                serves.
              </p>
              <hr />

              <h4 className="mt-4">Data Storage and Retention:</h4>
              <p>
                At ShubhPaisa Finance Private Limited, we ensure that your
                personal data is stored securely and is retained only for as
                long as necessary to fulfill the purposes for which it was
                collected or as required under applicable legal, regulatory, and
                contractual obligations.
              </p>

              <p>
                Your information is stored on secure servers located in India or
                in jurisdictions that offer adequate levels of data protection.
                We implement appropriate technical and organizational safeguards
                to prevent unauthorized access, loss, misuse, or alteration of
                your data. These measures include encryption, access controls,
                secure data backups, and periodic security assessments.
              </p>

              <hr />

              <h4 className="mt-4">Cookies and Tracking Technologies:</h4>
              <p>
                ShubhPaisa Finance Private Limited uses cookies and similar
                tracking technologies to enhance user experience, analyze
                website traffic, and personalize content across our digital
                platforms. Cookies are small data files stored on your device
                when you visit our website or use our mobile application. These
                help us recognize you on subsequent visits, remember your
                preferences, and provide a more secure and efficient experience.
              </p>
              <p>We use different types of cookies, including:</p>
              <hr />

              <ol className="mt-3">
                <li className="mb-3">
                  Essential Cookies: Required for the functioning of the website
                  or app (e.g., login authentication, security).
                </li>

                <li className="mb-3">
                  Performance and Analytics Cookies: Help us understand how
                  users interact with our platform and improve functionality.
                </li>

                <li className="mb-3">
                  Functional Cookies: Remember your preferences and settings to
                  enhance usability.
                </li>
                <li className="mb-3">
                  Marketing Cookies: Used to deliver relevant advertisements and
                  measure their effectiveness.
                </li>
              </ol>
              <p>
                You can manage or disable cookies through your browser or device
                settings. However, disabling certain cookies may affect the
                functionality and performance of our services.
              </p>
              <p>
                By continuing to use our website or app, you consent to our use
                of cookies in accordance with this policy.
              </p>
              <p>
                We do not use cookies to collect sensitive personal data unless
                explicitly provided by you for a specific purpose.
              </p>
              <h4 className="mt-4">Data Security:</h4>
              <p>
                At ShubhPaisa Finance Private Limited, we prioritize the
                security of your personal data. We implement robust technical
                and organizational measures to protect your information from
                unauthorized access, loss, misuse, or alteration. These include
                encryption, secure servers, firewalls, multi-factor
                authentication, and regular security audits. Access to your data
                is restricted to authorized personnel on a need-to-know basis.
                While we strive to use industry-standard security practices, no
                method of transmission over the internet or electronic storage
                is completely secure. We encourage you to use strong passwords
                and report any suspected security incidents promptly.
              </p>

              <hr />

              <h4 className="mt-4">Your Rights and Choices:</h4>
              <p>
                As a user of ShubhPaisa Finance Private Limited's services, you
                have several rights regarding your personal data. We are
                committed to giving you control over how your data is handled.
                These rights include:
              </p>

              <ul>
                <li>
                  <strong>Right to Access:</strong> You can request a copy of
                  the personal data we hold about you.
                </li>
                <li>
                  <strong>Right to Rectification:</strong> If any information we
                  hold is incorrect or incomplete, you have the right to request
                  corrections.
                </li>
                <li>
                  <strong>Right to Erasure (Right to be Forgotten):</strong> You
                  may request that we delete your personal data, subject to
                  legal obligations or legitimate business needs for retaining
                  it.
                </li>
                <li>
                  <strong>Right to Restrict Processing:</strong> You can ask us
                  to limit the processing of your data, especially if you
                  believe the data is inaccurate or its processing is unlawful.
                </li>
                <li>
                  <strong>Right to Data Portability:</strong> You have the right
                  to obtain your personal data in a structured, commonly used,
                  and machine-readable format and to transfer it to another
                  service provider.
                </li>
                <li>
                  <strong>Right to Withdraw Consent:</strong> Where our
                  processing is based on consent, you can withdraw your consent
                  at any time, affecting future processing but not
                  retroactively.
                </li>
              </ul>

              <h6>Sharing and Disclosure of Information:</h6>
              <p>
                At ShubhPaisa Finance Private Limited, we are committed to
                maintaining the privacy and security of your personal data.
                However, we may share and disclose your information in the
                following circumstances:
              </p>

              <ul>
                <li>
                  <strong>Service Providers and Third Parties:</strong> We may
                  share your data with trusted third-party vendors or service
                  providers who assist us in delivering our services, including
                  credit bureaus, payment processors, IT support, customer
                  service providers, and others who perform services on our
                  behalf.
                </li>
                <li>
                  <strong>Regulatory and Legal Obligations:</strong> We may
                  disclose your information to regulatory authorities,
                  government agencies, or law enforcement bodies if required by
                  law, or to comply with legal obligations, such as KYC,
                  anti-money laundering (AML) requirements, or court orders.
                </li>
                <li>
                  <strong>Business Transfers:</strong> In the event of a merger,
                  acquisition, sale of assets, or other business transactions,
                  your personal information may be transferred to the acquiring
                  entity. In such cases, we will ensure that your data is
                  protected according to this Privacy Policy.
                </li>
                <li>
                  <strong>With Your Consent:</strong> We may share your data
                  with third parties if you have given explicit consent to do so
                  for a specific purpose.
                </li>
              </ul>

              <p>
                We do not sell, rent, or trade your personal information to
                third parties for marketing purposes.
              </p>

              <h6>Children’s Privacy:</h6>
              <p>
                ShubhPaisa Finance Private Limited’s services are not intended
                for individuals under the age of 18. We do not knowingly collect
                or process personal data from minors. If we become aware that we
                have inadvertently collected personal information from a child
                under 18, we will take immediate steps to delete such data. If
                you are a parent or guardian and believe we have collected
                personal data from a child, please contact us at [Insert Contact
                Email] to request the deletion of such information.
              </p>

              <h6>Changes to This Privacy Policy:</h6>
              <p>
                We reserve the right to update or modify this Privacy Policy at
                any time. Any changes will be posted on this page with the
                revised "Effective Date." We encourage you to review this
                Privacy Policy periodically to stay informed about how we are
                protecting your data. Continued use of our services after any
                updates to the Privacy Policy indicates your acceptance of the
                changes. If significant changes are made, we may notify you via
                email or through prominent notices on our Platform.
              </p>

              <h6>Third-Party Links:</h6>
              <p>
                Our Platform may contain links to third-party websites or
                services. We are not responsible for their privacy practices. We
                encourage users to read third-party privacy policies before
                interacting with them.
              </p>

              <hr />

              <h4 className="mt-4">Contact Us</h4>
              <p className="mb-1">
                <strong>Shubhpaisa Finance Private Limited</strong>
              </p>
              <p className="mb-0">Email: customercare@subhpaisa.com</p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Privacypolicy;
